import lodash from "lodash";
import { createColumnInput } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { createButtonCreate } from "../../../../utils/button";
import { onClickDeleteAllClient } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { createManageDelete, createPage, createRowActionEdit, createRowActionView } from "../../../../utils/page";
import { openModalForm as openModalUserForm } from "../../modal/user-modal/user-modal.logic";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/hazDiscussUseRate";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.request.register.idCard"),
            dataIndex: "idCard",
            align: "center",
            search: { visible: () => false },
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.register.fullnameTh"),
            dataIndexValue: ({ record }) => `${record.refTitle.value} ${record.firstNameTh} ${record.lastNameTh}`,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            search: { visible: () => false },
            align: "center",
        }),
    ];
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            },
        }),
    ];
    data.manageExtras = [
        {
            render: () =>
                createButtonCreate({
                    onClick: () =>
                        openModalUserForm({
                            props: { dataProp: { form: data.useForm.modelRef } },
                            itemsArr: items,
                        }),
                }),
            visible: () => (viewOnly ? false : canCreate),
        },
    ];
    data.rowActions = [
        createRowActionView({
            menuContext,
            onClick: ({ record }) => openModalUserForm({ props: { menuContext, viewOnly, setAppPageHeader: false, form: record } }),
        }),
        createRowActionEdit({
            menuContext,
            visible: () => !viewOnly,
            onClick: ({ record }) => openModalUserForm({ props: { menuContext, viewOnly, setAppPageHeader: false, form: record } }),
        })
    ];
    fetchData({ props, data }).then((page) => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
